import { Component } from '@angular/core';
import { CustomerDataComponent } from '../customer-data.component';

@Component({
  selector: 'vpfa-customer-data-mobile',
  templateUrl: './customer-data-mobile.component.html',
  styleUrls: ['./customer-data-mobile.component.scss'],
})
export class CustomerDataMobileComponent extends CustomerDataComponent {}
